/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _usePivot = _interopRequireDefault(require("./usePivot"));
var _renderGroupToolbar = _interopRequireDefault(require("./renderGroupToolbar"));
var _DragGroupItem = _interopRequireDefault(require("./DragGroupItem"));
var _react = _interopRequireDefault(require("react"));
var _maybeAddGroupColumn = _interopRequireDefault(require("./maybeAddGroupColumn"));
var _default = {
  name: 'group-and-pivot',
  hook: _usePivot.default,
  maybeAddColumns: function maybeAddColumns(columns, props) {
    if (props.groupBy && props.groupBy.length) {
      columns = (0, _maybeAddGroupColumn.default)(columns, props);
    }
    return columns;
  },
  defaultProps: function defaultProps() {
    return {
      renderGroupToolbar: _renderGroupToolbar.default,
      renderDragGroupItem: function renderDragGroupItem(ref) {
        return _react.default.createElement(_DragGroupItem.default, {
          ref: ref
        });
      }
    };
  }
};
exports.default = _default;